import { render } from "./ProjectsContent1.vue?vue&type=template&id=99059be8&scoped=true"
const script = {}

import "./ProjectsContent1.vue?vue&type=style&index=0&id=99059be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99059be8"]])

export default __exports__